if (!customElements.get('tos-halloween-countdown')) {
  customElements.define('tos-halloween-countdown', class extends HTMLElement {
    connectedCallback() {
      if (this.connected) return;
      this.connected = true;
      this.deadline = Date.parse(this.dataset.deadline);
      this.refresh = () => this.updateCountdown();
      this.formatLocalEnd();
      this.updateCountdown();
      if (Number.isFinite(this.deadline) && this.deadline > Date.now()) {
        this.interval = setInterval(this.refresh, 1000);
      }
      document.addEventListener('visibilitychange', this.refresh);
      window.addEventListener('pageshow', this.refresh);
    }

    formatLocalEnd() {
      const target = this.querySelector('[data-countdown-local-end]');
      if (!target || !Number.isFinite(this.deadline)) return;
      const options = { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', timeZoneName: 'short' };
      try {
        target.textContent = new Intl.DateTimeFormat(this.dataset.locale || 'en', options).format(this.deadline);
        const prefix = this.querySelector('[data-countdown-local-prefix]');
        if (prefix) prefix.hidden = false;
      } catch {
        try {
          target.textContent = new Intl.DateTimeFormat('en', options).format(this.deadline);
          const prefix = this.querySelector('[data-countdown-local-prefix]');
          if (prefix) prefix.hidden = false;
        } catch { /* Keep the server-rendered UTC fallback. */ }
      }
    }

    updateCountdown() {
      const remaining = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
      const clock = this.querySelector('[data-countdown-clock]');
      if (!Number.isFinite(remaining) || remaining === 0) {
        if (clock) clock.hidden = true;
        this.querySelector('[data-countdown-heading]').textContent = this.dataset.ended;
        this.setAttribute('aria-label', this.dataset.ended);
        const campaign = this.closest('[data-tos-halloween-campaign]');
        if (campaign) campaign.querySelectorAll('[data-tos-halloween-active]').forEach(element => { element.hidden = true; });
        clearInterval(this.interval);
        this.interval = null;
        return;
      }
      const values = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60 };
      for (const [unit, value] of Object.entries(values)) {
        this.querySelector(`[data-countdown-${unit}]`).textContent = String(value).padStart(2, '0');
      }
      if (clock) clock.hidden = false;
    }

    disconnectedCallback() {
      clearInterval(this.interval);
      document.removeEventListener('visibilitychange', this.refresh);
      window.removeEventListener('pageshow', this.refresh);
      this.connected = false;
    }
  });
}
